import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'webhookEventTypeLabel',
})
export class WebhookEventTypeLabelPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }

    const withoutPrefix: string[] = value.split('.').slice(1);
    const segments: string[] = withoutPrefix.length ? withoutPrefix : value.split('.');
    const words: string[] = segments
      .join(' ')
      .split(/[._\s]+/)
      .filter(Boolean);

    return words.map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }
}
